import { DbRef } from '@caresend/types';
import { isLocationEmpty } from './location.js';
import { getPath } from './path.js';
import { formatTimeZoneDateSimple } from '../formatters/date.js';
import { isEncrypted } from '../typeValidation/basicGuards.js';
import { isNullish } from '../typeValidation/nullish.js';

const isOrderComplete = draftWaypoint => draftWaypoint ? !draftWaypoint.draftOrderID : false;
/**
 * ```
 * `${DbRef.DRAFT_WAYPOINTS}/${id}/${childPath}`
 * ```
 */

function getDraftWaypointPath(id, childPath) {
  return getPath(`${DbRef.DRAFT_WAYPOINTS}/${id}`, childPath);
}
/**
 * Determine if a value is a draft waypoint.
 */

const isDraftWaypoint = value => {
  if (typeof value !== 'object' || isNullish(value)) return false;
  if ('procedures' in value && !('draftWaypointID' in value)) return true;
  return false;
};
const isDraftWaypointDenormalized = draftWaypoint => draftWaypoint.procedureIDs !== undefined;
const getDateTimeFromDraftWaypoint = draftWaypoint => {
  var _a, _b, _c;

  const isDenormalized = isDraftWaypointDenormalized(draftWaypoint);
  return isDenormalized ? draftWaypoint.date : (_b = (_a = draftWaypoint.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) !== null && _b !== void 0 ? _b : (_c = draftWaypoint.finalizedDate) === null || _c === void 0 ? void 0 : _c.date;
};
const getDraftWaypointDateTimeLabels = draftWaypoint => {
  if (!draftWaypoint) return {
    dateLabel: undefined,
    timeLabel: undefined
  };
  const datetime = getDateTimeFromDraftWaypoint(draftWaypoint);
  if (!datetime) return {
    dateLabel: undefined,
    timeLabel: undefined
  };
  const dateLabel = formatTimeZoneDateSimple(datetime, 'MMMM D');
  const timeLabel = formatTimeZoneDateSimple(datetime, 'h:mm a');
  return {
    dateLabel,
    timeLabel
  };
};
/**
 * Check if a location has been set for a draft waypoint. Previously, draft
 * waypoints were initialized with a location of 0,0. New draft waypoints are
 * initialized without a location property.
 */

const getDraftWaypointHasLocation = draftWaypoint => !isLocationEmpty(draftWaypoint.location);
const getIsDraftWaypointEncrypted = draftWaypoint => isEncrypted(draftWaypoint.location);

export { getDateTimeFromDraftWaypoint, getDraftWaypointDateTimeLabels, getDraftWaypointHasLocation, getDraftWaypointPath, getIsDraftWaypointEncrypted, isDraftWaypoint, isDraftWaypointDenormalized, isOrderComplete };
